import React, { useContext } from 'react';
import { useCollectionData } from 'react-firebase-hooks/firestore';

import { Context } from '../../index';

import SupportAdmin from './SupportAdmin';
import SupportClient from './SupportClient';

const Support = () => {
  const { firestore, auth } = useContext(Context);

  const user = auth.currentUser;
  const userId = user?.uid;
  const [supportIds, loading] = useCollectionData(firestore.collection('support_ids'));

  if (loading) return null;

  const isAdmin = !!supportIds?.find((item) => item.support_id === userId);

  return isAdmin ? <SupportAdmin supportIds={supportIds} /> : <SupportClient />;
};

export default Support;
